import { Grid } from '@mui/material';
import { ReactNode } from 'react';
import { Item, WsColors, WsPageHeader } from 'wisestep-base';

import { IOption } from '../../components/SettingsIndex';
import { IBreadCrumbsList, WsBreadCrumbs } from '../../components/WsBreadCrumbs';

import SettingsMenu from './components/SettingsMenu';

type IAppSettingsLayoutProps = {
  title: string;
  backUrl?: string;
  breadCrumnbsList?: IBreadCrumbsList[];
  children: ReactNode;
  options?: IOption[];
  getSelectedOption?: (option: number) => void;
  getSelectedSubOption?: (subOption: number) => void;
};

const AppSettingsLayout = ({
  title,
  children,
  options,
  getSelectedOption,
  getSelectedSubOption,
  breadCrumnbsList = [],
}: IAppSettingsLayoutProps) => (
  <Grid container columnSpacing={3} rowSpacing={4}>
    <Grid item xs={12}>
      <WsBreadCrumbs breadCrumbsList={breadCrumnbsList} />
      <WsPageHeader title={title} />
    </Grid>
    <Grid item xs={3}>
      <SettingsMenu
        options={options}
        getSelectedOption={getSelectedOption}
        getSelectedSubOption={getSelectedSubOption}
      />
    </Grid>
    <Grid item xs={9}>
      <Item sx={{ backgroundColor: WsColors.White, height: '100%' }}>{children}</Item>
    </Grid>
  </Grid>
);

export default AppSettingsLayout;
